import React from 'react';
import classnames from 'classnames'
import { connect } from 'react-redux';
import { withRouter } from 'react-router';
import { bindActionCreators } from 'redux';
import { Translate, withLocalize } from 'react-localize-redux';
import { popupActions } from '../../../store/popupStore';

import './quickReport.scss';

class QuickReportFinDataUpdate extends React.Component {
    shouldComponentUpdate(nextProps, nextState) {
        return this.props.dataHash !== nextProps.dataHash;
    }

    render() {
        return (this.props.data === undefined || this.props.data === null ? null : this.renderContent(this.props.data));
    }

    renderContent(data) {
        return (
            <div className="columns">
                <div className="column is-12">
                    <div className="qr-fs-update-desc">
                        <Translate id="Report.Quick.FinDataUpdate.Description" />
                    </div>
                    <div className="qr-fs-update-btn-box">
                        <button className={classnames('bb-button gradient-1', {'is-square': localStorage.locales_button_style === 'square'})} onClick={() => this.showPopup(data)}>
                            <Translate id="Report.Quick.FinDataUpdate.ButtonLabel" />
                        </button>
                    </div>
                </div>
            </div>
        )
    }

    showPopup = (data) => {
        this.props.showPopup('quickReportFinDataUpdatePopup',
        {
            title: this.props.translate('Report.Quick.FinDataUpdate.Form.Header2'),
            open: true,
            close: () => { this.props.hidePopup(); },
            data: { formData: data, entityId: this.props.id }
        });
    }
}

export default withLocalize(withRouter(connect(
    state => ({}),
    dispatch => bindActionCreators({ ...popupActions }, dispatch)
)(QuickReportFinDataUpdate)));